// extracted by mini-css-extract-plugin
export default {"card":"Statistics_card__W7vlB","subtitle":"Statistics_subtitle__J9fMG","message":"Statistics_message__km6Cb","stat":"Statistics_stat__c8EvN"};